import React from 'react';
import { pick } from 'lodash';
import { Icon } from 'ui';
import { Upload } from 'react-feather';
import FileStackImage from 'misc/filestack_image';
import ImageLibraryPicker from 'components/shared/ImageLibraryPicker';
import ImageLibraryAddDialog from 'components/shared/ImageLibraryAddDialog';
import { connect, useSelector } from 'react-redux';
import * as actions from '../../actions/editor/template';

const LinkButton = props => (
  <button
    type="button"
    className="TemplateImageUpload-linkButton u-linkBtn d-b mb-4"
    {...props}
  />
);

const LessonTemplateImageUpload = props => {
  const {
    contentId,
    contentType,
    imageType,
    allowImageLibrary,
    canManageContentLibrary,
    onTemplateImageChange,
    onRemoveTemplateImage,
    onToggleAddToLibrary,
    onToggleImageLibrary,
    onImageLibrarySelect,
  } = props;

  const { image, addToLibraryVisible, imageLibraryVisible } = useSelector(
    state => state.editor.templates[imageType],
  );

  const toggleAddToImageLibrary = () => {
    onToggleAddToLibrary(!addToLibraryVisible, imageType);
  };

  const toggleImageLibrary = () => {
    onToggleImageLibrary(!imageLibraryVisible, imageType);
  };

  const handleUploadImage = () => {
    const imageParams = {
      content_id: contentId,
      content_type: contentType,
      image_type: imageType,
    };

    onTemplateImageChange(imageParams);
  };

  const handleRemoveImage = () => {
    const imageParams = {
      image: {
        content_id: contentId,
        content_type: contentType,
        image_type: imageType,
      },
    };
    onRemoveTemplateImage(image, imageParams);
  };

  const handleImageLibrarySelect = selectedImage => {
    const selectedImageParams = {
      content_id: contentId,
      content_type: contentType,
      image_type: imageType,
      image_id: selectedImage.id,
    };

    onImageLibrarySelect(selectedImageParams);
  };

  let filestackImage = null;
  if (image) {
    filestackImage = new FileStackImage({
      ...pick(image, ['signature', 'policy', 'handle']),
      transform: {
        resize: { width: 444, height: 250, fit: 'crop', align: 'center' },
      },
    });
  }

  return (
    <div className="TemplateImageUpload mb-24">
      {imageLibraryVisible && (
        <ImageLibraryPicker
          onSelect={handleImageLibrarySelect}
          onDismiss={toggleImageLibrary}
        />
      )}
      {!image && (
        <div className="TemplateImageUpload-actions">
          <Upload size="32" className="mx-a mb-16" />
          <LinkButton
            children={t('templates.image_upload.upload_image')}
            onClick={handleUploadImage}
          />
          {allowImageLibrary && (
            <LinkButton
              children={t('templates.image_upload.select_from_image_library')}
              onClick={toggleImageLibrary}
            />
          )}
        </div>
      )}
      {image && (
        <>
          <img src={filestackImage.url} alt={image.name} />
          <div className="mt-16">
            <LinkButton
              className="u-linkBtn fz-base fw-n"
              onClick={handleRemoveImage}
            >
              <Icon name="delete" className="mr-2" /> Remove
            </LinkButton>
          </div>
        </>
      )}
      <ImageLibraryAddDialog
        canManageContentLibrary={canManageContentLibrary}
        image={image}
        visible={image && addToLibraryVisible}
        toggleVisible={toggleAddToImageLibrary}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onTemplateImageChange: imageParams =>
    dispatch(actions.uploadToFilestack(imageParams)),
  onRemoveTemplateImage: (image, imageParams) =>
    dispatch(actions.removeImage(image, imageParams)),
  onToggleAddToLibrary: (visible, imageType) =>
    dispatch(actions.templateToggleAddToLibrary(visible, imageType)),
  onToggleImageLibrary: (visible, imageType) =>
    dispatch(actions.templateToggleImageLibrary(visible, imageType)),
  onImageLibrarySelect: imageParams =>
    dispatch(actions.selectLibraryImage(imageParams)),
});

export default connect(null, mapDispatchToProps)(LessonTemplateImageUpload);
